import notificationHelper from '@utils/notificationHelper';

const processNotifications = (notificationsToProcess, goalUID) => {
  try {
    const notifications =
      notificationsToProcess?.notifications?.map?.((item) => {
        const { det } = item || {};
        const { url } = det || {};
        let href;
        let urlPath = url ? url.replace('https://unacademy.com', '') : '';
        const type = item.type ? item.type.toLowerCase() : '';

        if (type === 'testresultsready') {
          urlPath = urlPath.replace(/\/$/, '');
          const sessionuid = urlPath.split(/\/results\/(.*)/)[1];
          href = {
            pathname: notificationHelper.getHref(type),
            query: { sessionuid }
          };
          urlPath = urlPath.replace('/results/', '?sessionuid=');
        } else if (type === 'dailypracticepractice') {
          href = '/goal/[goalSlug]/[goalUID]/practice';
          urlPath = `/goal/${goalUID.goalSlug}/${goalUID.uid}/practice`;
        } else if (urlPath && urlPath.endsWith('/planner')) {
          // handling href for platform batch groups notifications
          href = '/goal/[goalSlug]/[goalUID]/planner';
        } else {
          href = notificationHelper.getHref(type) || urlPath || '';
        }
        const as = urlPath;

        return { ...item, type, det: { ...det, href, as, urlPath } };
      }) || [];
    return notifications;
  } catch {
    return [];
  }
};

export default processNotifications;
